<template>
  <div>
    <b-form-select
      v-model="selected"
      :options="options"
      :value-field="text"
      :text-field="text"
      @change="changeHandler"
    >
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: {
    options: {
      type: Array
    },
    value: [String, Number],
    text: [String, Number]
  },
  data() {
    return {
      selected: null,
    }
  },
  methods: {
    changeHandler() {
      this.$emit('changeSelected', this.selected)
    }
  }
}
</script>

<style scoped>

</style>
